export const CHANGE_INDEX_EVENT = 'changeIndexEvent';

export type ChangeIndexEventListener = EventListener & {
  detail: number;
};

export const dispatchChangeIndexEvent = (newIndex: number) => {
  const customEvent = new CustomEvent<number>(CHANGE_INDEX_EVENT, { detail: newIndex });
  window.dispatchEvent(customEvent);
};
